import { Injector } from '@angular/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { Node } from '@tiptap/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { parseJsonAttr } from '../parse-json-attr.util';
import { DEFAULT_ECHARTS_PROPS, ECHARTS_NODE_NAME } from './echarts.model';
import { EchartsNodeComponent } from './echarts-node.component';

export const EchartsExtension = (injector: Injector) => {
  return Node.create({
    name: ECHARTS_NODE_NAME,
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        id: {
          default: '',
          renderHTML: (attributes) => ({ 'data-id': attributes['id'] }),
          parseHTML: (element) => element.getAttribute('data-id') ?? '',
        },
        options: {
          default: DEFAULT_ECHARTS_PROPS.options,
          renderHTML: (attributes) => ({ 'data-options': JSON.stringify(attributes['options']) }),
          parseHTML: (element) => parseJsonAttr(element, 'data-options', DEFAULT_ECHARTS_PROPS.options),
        },
        height: {
          default: DEFAULT_ECHARTS_PROPS.height,
          renderHTML: (attributes) =>
            attributes['height'] !== null ? { 'data-height': String(attributes['height']) } : {},
          parseHTML: (element) => {
            const val = element.getAttribute('data-height');
            return val ? parseInt(val, 10) : null;
          },
        },
        custom_css: {
          default: '',
          renderHTML: (attributes) => (attributes['custom_css'] ? { 'data-custom-css': attributes['custom_css'] } : {}),
          parseHTML: (element) => element.getAttribute('data-custom-css') ?? '',
        },
        custom_style: {
          default: null,
          renderHTML: (attributes) =>
            attributes['custom_style'] ? { 'data-custom-style': JSON.stringify(attributes['custom_style']) } : {},
          parseHTML: (element) => parseJsonAttr(element, 'data-custom-style', null),
        },
      };
    },

    parseHTML() {
      return [{ tag: 'div.echarts-block' }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', { class: 'echarts-block', ...HTMLAttributes }];
    },

    addNodeView() {
      return AngularNodeViewRenderer(EchartsNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
